import React from "react";
import { IconInfoCircle } from "@tabler/icons-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface OverviewSectionWrapperProps {
  title: string;
  titleIcon?: React.ComponentType<{ className?: string }>;
  showInfoIcon?: boolean;
  tooltipContent?: string;
  className?: string;
  children: React.ReactNode;
  rightSideHeader?: React.ReactNode;
}

const OverviewSectionWrapper: React.FC<OverviewSectionWrapperProps> = ({
  title,
  titleIcon: TitleIcon,
  showInfoIcon = false,
  tooltipContent = "More information",
  className = "",
  children,
  rightSideHeader,
}) => {
  return (
    <TooltipProvider>
      <div
        className={`flex flex-col gap-4 p-[8px] rounded-[16px] squircle squircle-radius-[16px] squircle-outline-color-border-gray squircle-outline-[1px] bg-white ${className}`}
      >
        {/* Header with title and optional info icon */}
        {title && (
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-[8px]">
              {TitleIcon && (
                <div className="h-[32px] w-[32px] flex items-center justify-center squircle-mask squircle-outline-[0] bg-selected-gray/80">
                  <TitleIcon className="h-4 w-4 text-brand-primary-800" />
                </div>
              )}
              <h3 className="text-[12px] font-medium text-brand-primary-new leading-[24px]">
                {title}
              </h3>
              {showInfoIcon && (
                <Tooltip>
                  <TooltipTrigger asChild>
                    <IconInfoCircle size={14} className="text-brand-primary-400" />
                  </TooltipTrigger>
                  <TooltipContent side="bottom" align="start" className="max-w-[300px]">
                    <p>{tooltipContent}</p>
                  </TooltipContent>
                </Tooltip>
              )}
            </div>
            {rightSideHeader}
          </div>
        )}

        {/* Content area */}
        <div className="overflow-auto">{children}</div>
      </div>
    </TooltipProvider>
  );
};

export default OverviewSectionWrapper;
